(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        !this.mobileMediaQuery.matches && (this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size');
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      this.headerIsAlwaysSticky = !this.mobileMediaQuery.matches &&
        ['always', 'reduce-logo-size'].includes(this.getAttribute('data-sticky-type'));
      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen) ||
          this.querySelector('.sv-catalogue details[open], header-drawer details[open]') ||
          this.contains(document.activeElement) && document.activeElement.matches('input, textarea, select')) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["storm-footer"]) return;
  try {
    
  const stormFooterScreen = window.matchMedia('(min-width: 750px)');
  function updateStormFooter() {
    document.querySelectorAll('.storm-footer__menu').forEach(menu => { menu.open = stormFooterScreen.matches; });
  }
  updateStormFooter();
  stormFooterScreen.addEventListener('change', updateStormFooter);
  document.addEventListener('shopify:section:load', updateStormFooter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["storm-product-details"] && !Shopify.designMode) return;
  try {
    
  function setupStormProduct() {
    const main = document.querySelector('.sv-product-shell');
    const dock = document.querySelector('[data-storm-buy-dock]');
    if (!main || !dock || dock.dataset.initialized) return;
    dock.dataset.initialized = 'true';
    const button = dock.querySelector('[data-storm-dock-submit]');
    const price = dock.querySelector('[data-storm-dock-price]');
    const error = dock.querySelector('[data-storm-dock-error]');
    const quantity = dock.querySelector('[data-storm-dock-quantity]');
    const minus = dock.querySelector('[data-storm-dock-minus]');
    const plus = dock.querySelector('[data-storm-dock-plus]');
    const sourceQuantity = () => main.querySelector('quantity-input input[name="quantity"]') || main.querySelector('input[name="quantity"]');
    function changeQuantity(direction) {
      const source = sourceQuantity();
      if (!source || source.disabled) return;
      if (direction) {
        if (direction > 0) source.stepUp(); else source.stepDown();
      } else {
        const min = Number(source.min) || 1;
        const max = source.max === '' ? Infinity : Number(source.max);
        const step = Number(source.step) || 1;
        const value = Number(quantity.value);
        source.value = String(Math.min(max, Math.max(min, min + Math.round(((Number.isFinite(value) ? value : min) - min) / step) * step)));
      }
      source.dispatchEvent(new Event('change', {bubbles:true}));
      sync();
    }
    minus.addEventListener('click', () => changeQuantity(-1));
    plus.addEventListener('click', () => changeQuantity(1));
    quantity.addEventListener('change', () => changeQuantity(0));
    main.addEventListener('change', sync);
    function sync() {
      const source = main.querySelector('product-form form [type="submit"]');
      if (!source) { dock.hidden = true; return; }
      button.setAttribute('form', source.form.getAttribute('id'));
      button.disabled = source.disabled || source.getAttribute('aria-disabled') === 'true';
      button.textContent = source.querySelector('span')?.textContent.trim() || source.textContent.trim();
      const sourceInput = sourceQuantity();
      if (sourceInput) {
        quantity.value = sourceInput.value;
        quantity.min = sourceInput.min || '1';
        quantity.step = sourceInput.step || '1';
        if (sourceInput.max) quantity.max = sourceInput.max; else quantity.removeAttribute('max');
        quantity.disabled = button.disabled || sourceInput.disabled;
        minus.disabled = quantity.disabled || Number(quantity.value) <= Number(quantity.min);
        plus.disabled = quantity.disabled || (quantity.max !== '' && Number(quantity.value) >= Number(quantity.max));
      } else { quantity.disabled = minus.disabled = plus.disabled = true; }
      const rootPrice = main.querySelector('[id^="price-"] .price');
      const amount = rootPrice?.querySelector(rootPrice.classList.contains('price--on-sale') ? '.price-item--sale' : '.price__regular .price-item--regular');
      price.textContent = amount?.textContent.trim() || '';
      const sourceError = main.querySelector('.product-form__error-message-wrapper');
      const message = sourceError && !sourceError.hidden ? sourceError.querySelector('.product-form__error-message')?.textContent.trim() : '';
      if (error.textContent !== message) error.textContent = message || '';
      error.hidden = !message;
      const rect = source.getBoundingClientRect();
      dock.hidden = rect.top >= 90 && rect.bottom <= window.innerHeight - 24;
    }
    const observer = new MutationObserver(sync);
    observer.observe(main, {subtree: true, childList: true, attributes: true, attributeFilter: ['disabled','aria-disabled','hidden','class']});
    new ResizeObserver(sync).observe(main);
    document.fonts.ready.then(sync);
    window.addEventListener('load', sync, {once: true});
    window.addEventListener('scroll', sync, {passive: true});
    window.addEventListener('resize', sync, {passive: true});
    sync();
  }
  setupStormProduct();
  document.addEventListener('shopify:section:load', setupStormProduct);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["storm-store-footer"] && !Shopify.designMode) return;
  try {
    
  const storeFooterMedia = matchMedia('(min-width: 750px)');
  function syncStoreFooter() { document.querySelectorAll('.sv-store-footer__links').forEach(e=>{e.open=storeFooterMedia.matches;}); }
  syncStoreFooter();storeFooterMedia.addEventListener('change',syncStoreFooter);document.addEventListener('shopify:section:load',syncStoreFooter);

  } catch(e) { console.error(e); }
})();
})();
